const statusStr = {FreeRoom:'未预约',Forbid:'不可预约',MyReserved:'已预约',OtherReserved:'已被预约',Complete:'已使用'}
export const baseMixins = {
	methods: {
		isPassed(date,event,now){
			let [hour,minute] = event.BeginTime.split(':')
			let newDate = new Date(date.getFullYear(),date.getMonth(),date.getDate(),hour,minute)
			// 开始时间后一个半小时内，仍允许预约：90 * 60 * 1000
			if (now - newDate  > 5400000) {
				return true
			}
			return false
		},
		getRoomStatus(status,date) {
			if (date && date.getDay() == 0) return '非营业时间'
			return statusStr[status]
		},

		/**
		 * checkCode: 
		 *  1  允许预约
		 *  0  18号后才能预约
		 *  -1 不能预约
		 */
		checkRank (rank, firstDay, secondDay, openHour1,openHour2,now) {
			const nowDay = now.getDate()
			const nowHour = now.getHours()
			let checkCode = -1
			if ((nowDay > firstDay) || (nowDay === firstDay && nowHour >= openHour1)) {
				if ((nowDay < secondDay) || (nowDay === secondDay && nowHour < openHour2)) {
					if (rank >= 9) {
						checkCode = 1
					} else if (rank >= 7) {
						checkCode = 0
					}
				} else {
					if (rank >= 7) {
						checkCode = 1
					}
				}
			}
			return checkCode
		},
		checkTime (time) {
			const  now = new Date()
			time = new Date(time.replace(' ','T'))
			const  diff = now - time
			console.log(diff)
			if (diff > 3 * 60 * 1000 || diff < -1 * 3 * 60 * 1000 ) {
				return true
			}
			return false
		},
		async getServeTime () {
			const result = await this.getUserRankAction()
			let serveTime = result?.response?.time
			return new Date(serveTime.replace(' ', 'T'))
		}
	}
}